export const Switch = {
  defaultProps: {
    onTrackColor: 'tertiary.800',
    onThumbColor: 'white',
    offTrackColor: '#C2C2C2'
  },
  sizes: {
    sm: {
      style: {
        transform: [{ scale: 0.75 }]
      }
    },
    // md: {},
    lg: {
      style: {
        transform: [{ scale: 1 }]
      }
    }
  }
}
